var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createRef } from 'react';
import classnames from 'classnames';
import Slider from 'rc-slider';
import { Icon, Header } from '@mademine/components';
import { Gtag, I18n } from '@mademine/utils';
import clip, { MODE_TOUCH } from 'sunzi-plugin-clip';
import Carousel from 'nuka-carousel';
import { loadHTMLImage } from '../../utils';
import { ReactComponent as IconQuestion } from '../../assets/icon-question.svg';
import { ReactComponent as IconRevoke } from '../../assets/icon-revoke.svg';
import { ReactComponent as IconGestureMove } from '../../assets/icon-gesture-move.svg';
import { ReactComponent as IconScissors } from '../../assets/icon-scissors.svg';
import { ReactComponent as IconLeft } from '../../assets/icon-arrow-bold-left.svg';
import Guide from '../../components/Guide';
import ImageLoad from '../../components/ImageLoad';
import styles from './style.module.less';
var Clip = (function (_super) {
    __extends(Clip, _super);
    function Clip(props) {
        var _this = _super.call(this, props) || this;
        _this._element = createRef();
        _this._canvas = createRef();
        _this._preZoom = 1;
        _this.toClipURL = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._clip) return [3, 2];
                        return [4, this._clip.toClipURL()];
                    case 1: return [2, _a.sent()];
                    case 2: return [2];
                }
            });
        }); };
        _this.handleRevoke = function () {
            if (_this._clip) {
                _this._clip.revoke();
                Gtag.event('clip_footer_click', { event_label: 'revoke' });
            }
        };
        _this.handleGustureChange = function (type) {
            var _a;
            _this.setState({
                gusture: type
            });
            (_a = _this._clip) === null || _a === void 0 ? void 0 : _a.modeToggle();
        };
        _this.onGuideVisible = function (visible) { return function () {
            window.localStorage.setItem('_sunzi_clip_guide', '0');
            _this.setState({
                guideVisible: visible
            });
            if (visible) {
                Gtag.event('clip_footer_click', { event_label: 'help' });
            }
        }; };
        _this.handleChangeZoom = function (value) {
            var _a, _b;
            var zoom = typeof value === 'number' ? value : value[0];
            if (_this._preZoom === zoom)
                return;
            _this.setState({
                zoom: zoom
            });
            if (zoom > _this.state.zoom) {
                var scale = Math.pow(1.1, zoom - _this.state.zoom);
                (_a = _this._clip) === null || _a === void 0 ? void 0 : _a.zoomIn(scale);
            }
            else {
                var scale = Math.pow(0.9, _this.state.zoom - zoom);
                (_b = _this._clip) === null || _b === void 0 ? void 0 : _b.zoomOut(scale);
            }
            _this._preZoom = zoom;
        };
        var guideVisible = !!parseInt(window.localStorage.getItem('_sunzi_clip_guide') || '1');
        _this.state = {
            revokeDisabled: true,
            gusture: MODE_TOUCH.pan,
            guideVisible: guideVisible,
            zoom: 1
        };
        return _this;
    }
    Clip.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var source, _a, offsetWidth, offsetHeight, scale, _image;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        source = this.props.source;
                        if (!(this._element.current && this._canvas.current && source)) return [3, 2];
                        _a = this._element.current, offsetWidth = _a.offsetWidth, offsetHeight = _a.offsetHeight;
                        scale = Math.min(1200 / offsetWidth, 1200 / offsetHeight);
                        this._canvas.current.width = offsetWidth * scale;
                        this._canvas.current.height = offsetHeight * scale;
                        return [4, loadHTMLImage(source)];
                    case 1:
                        _image = _b.sent();
                        this._clip = new clip(this._canvas.current, _image, {
                            lineWidth: 4,
                            lineOutWidth: 10,
                            lineColor: '#ff0136',
                            lineOutColor: 'rgba(255, 255, 255, .2)',
                            closedLineWidth: 10,
                            closedLineOutWidth: 15,
                            closedLineColor: 'rgba(255, 255, 255, 1)',
                            closedLineOutColor: 'rgba(0, 0, 0, .5)',
                            endpointColor: 'rgba(0, 0, 0, .5)',
                            onStackChange: function (stack) {
                                var revokeDisabled = _this.state.revokeDisabled;
                                if (stack.length === 0 && !revokeDisabled) {
                                    _this.setState({
                                        revokeDisabled: true
                                    });
                                }
                                else if (stack.length > 0 && revokeDisabled)
                                    _this.setState({
                                        revokeDisabled: false
                                    });
                            }
                        });
                        _b.label = 2;
                    case 2: return [2];
                }
            });
        });
    };
    Clip.prototype.dispose = function () {
        if (this._clip)
            this._clip.dispose();
    };
    Clip.prototype.render = function () {
        var _a, _b, _c, _d;
        var _this = this;
        var _e = this.state, revokeDisabled = _e.revokeDisabled, gusture = _e.gusture, guideVisible = _e.guideVisible;
        var theme = this.props.theme;
        return (_jsxs("div", { className: classnames(styles.clip, ' _sz-flex _sz-flex-col', (_a = {},
                _a[styles['clip-light']] = theme === 'light',
                _a)), children: [_jsx(Header, { className: "_sz-border-none _sz-bg-white", renderCloseContent: _jsx("div", { className: "_sz-p-1.5", onClick: this.props.onClose, children: _jsx(Icon, { size: 24, color: "rgba(0, 0, 0, 0.88)", children: _jsx(IconLeft, {}) }) }), onClose: this.props.onClose, renderContent: _jsxs("div", { className: "_sz-flex _sz-items-center _sz-justify-start", children: [_jsx("h1", { className: "_sz-m-0 _sz-mr-1 _sz-p-0 _sz-text-base _sz-font-extrabold !_sz-leading-6 _sz-text-black/[.88]", children: I18n.format('components.cropper.crop') }), _jsx("div", { className: " _sz-cursor-pointer", onClick: function () {
                                    _this.onGuideVisible(true)();
                                }, children: _jsx(Icon, { size: 24, children: _jsx(IconQuestion, {}) }) })] }), renderConfirmContent: _jsx("div", { className: "_sz-mr-4 _sz-cursor-pointer _sz-rounded _sz-bg-black _sz-py-2\t_sz-px-4 _sz-text-base _sz-font-black _sz-text-white", onClick: this.props.onClipConfirm, children: I18n.format('modules.global.done') }) }), _jsx("div", { ref: this._element, className: classnames(styles['clip-content'], '_sz-flex-1'), children: _jsx("canvas", { ref: this._canvas }) }), _jsx("div", { className: "_sz-hidden _sz-h-12 _sz-bg-white _sz-px-[50px] md:_sz-flex md:_sz-items-center", children: _jsx(Slider, { min: 1, max: 18, step: 1, value: this.state.zoom, onChange: this.handleChangeZoom }) }), _jsxs("div", { className: styles['clip-footer'], children: [_jsxs("div", { className: classnames(styles['icon-wrapper'], (_b = {},
                                _b[styles['icon-wrapper-disabled']] = revokeDisabled,
                                _b)), onClick: this.handleRevoke, children: [_jsx(Icon, { size: 28, children: _jsx(IconRevoke, {}) }), _jsx("span", { children: I18n.format('components.cropper.back') })] }), _jsxs("div", { className: classnames(styles['icon-wrapper'], (_c = {},
                                _c[styles['icon-wrapper-active']] = gusture === MODE_TOUCH.pan,
                                _c)), onClick: function () { return _this.handleGustureChange(MODE_TOUCH.pan); }, children: [_jsx(Icon, { size: 28, children: _jsx(IconScissors, {}) }), _jsx("span", { children: I18n.format('components.cropper.crop') })] }), _jsxs("div", { className: classnames(styles['icon-wrapper'], (_d = {},
                                _d[styles['icon-wrapper-active']] = gusture === MODE_TOUCH.move,
                                _d)), onClick: function () { return _this.handleGustureChange(MODE_TOUCH.move); }, children: [_jsx(Icon, { size: 28, children: _jsx(IconGestureMove, {}) }), _jsx("span", { children: I18n.format('components.cropper.move') })] })] }), guideVisible && (_jsx(Guide, { onClose: this.onGuideVisible(false), children: _jsxs(Carousel, { autoplay: true, renderCenterLeftControls: null, renderCenterRightControls: null, children: [_jsx(ImageLoad, { source: "https://sunzi7n.imaiyuan.com/sock/clip-guide-1.gif", style: { width: 240, height: 240 } }), _jsx(ImageLoad, { source: "https://sunzi7n.imaiyuan.com/sock/clip-guide-2.gif", style: { width: 240, height: 240 } }), _jsx(ImageLoad, { source: "https://sunzi7n.imaiyuan.com/sock/clip-guide-3.gif", style: { width: 240, height: 240 } })] }) }))] }));
    };
    return Clip;
}(React.Component));
export default Clip;
